import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { makeRequest } from '@app/utils';

const minimumImageSize = 2000;

export const useCoverArtFetch = (
  isbns: string[] = [],
  isEnabled = true
): UseQueryResult<string> => {
  return useQuery(
    ['coverArt', isbns],
    () =>
      makeRequest<Blob>({
        url: '/opac-inventory/cover-art-image',
        params: {
          isbn: isbns[0],
          size: 'L',
          returnStatus: 'E',
        },
        responseType: 'blob',
        headers: {
          Accept: '*/*',
        },
      }).then(imageBlob => {
        if (imageBlob.size > minimumImageSize) {
          const urlCreator = window.URL || window.webkitURL;

          return urlCreator.createObjectURL(imageBlob);
        }

        return null;
      }),
    {
      enabled: Boolean(isbns?.[0] && isEnabled),
      staleTime: 1000 * 60 * 60 * 24,
    }
  );
};
